module.exports = __webpack_public_path__ + "img/card_two.bc0c3c65.png";